module.exports = __webpack_public_path__ + "static/media/icalendar-arrow-right.a1366de0.svg";